export const routes = {
  home: '/',
  perfumes: '/perfumes',
  tecnologia: '/tecnologia',
  joyeria: '/joyeria',
  cart: '/cart', 
  productDetail: '/product/:id',
  privacy: '/politica-de-privacidad',
  warranty: '/politica-de-garantia',
  search: '/search',
  blog: '/blog',
  blogPost: '/blog/:slug',
  registro: '/registro',
  login: '/login',
  misPedidos: '/mis-pedidos',     
  miCuenta: '/mi-cuenta',   
  reset: "/reset", 
  tilopayReturn: '/pago/tilopay',
};
